import { DateFormats, formatDate } from '@strata/helper-functions';
import dayjs from 'dayjs';

import { postClaim } from 'api/medbillingAPI';
import {
    ClaimFrequencyType,
    ClaimPlaceOfServiceMap,
    ClaimSubmissionType,
    ClaimUomMap,
} from 'services/MedicalBillingConstants';
import { AppThunk } from 'store';

export const submitClaim =
    (payload: {
        submissionType: ClaimSubmissionType;
        friendlyId: string;
        claimId: string;
        originalClaimNumber?: string;
        payerId: string;
        referralId: string;
        supplierNpi: string;
        taxonomyCode: string;
        placeOfService: keyof typeof ClaimPlaceOfServiceMap;
        memberId: string;
        patientAccountNumber: string;
        claimFrequencyType: ClaimFrequencyType;
        providerSignatureOnFile: string;
        providerAcceptAssignment: string;
        assignmentOfBenefits: string;
        releaseOfInformation: string;
        diagnoses: string[];
        services: {
            dateOfService: NonNullable<dayjs.ConfigType>;
            dateOfServiceEnd: NonNullable<dayjs.ConfigType>;
            procedureCode: string;
            procedureCodeDescription: string;
            modifierCodes?: string[];
            ndc?: string;
            diagnoses: string[];
            billingQty: number;
            billingQtyUom: keyof typeof ClaimUomMap;
            providerCharge: number;
            dispensedQty?: number;
            dispensedQtyUom?: keyof typeof ClaimUomMap;
        }[];
    }): AppThunk<Promise<string>> =>
    async (_, getState) => {
        const formattedClaim = {
            submission_type: payload.submissionType,
            friendly_id: payload.friendlyId,
            claim_id: payload.claimId,
            original_claim_number: payload.originalClaimNumber,
            payer_id: payload.payerId,
            referral_id: payload.referralId,
            supplier_npi: payload.supplierNpi,
            taxonomy_code: payload.taxonomyCode,
            place_of_service: payload.placeOfService,
            member_id: payload.memberId,
            patient_account_number: payload.patientAccountNumber,
            claim_frequency_type: payload.claimFrequencyType,
            provider_signature_on_file: payload.providerSignatureOnFile,
            provider_accept_assignment: payload.providerAcceptAssignment,
            assignment_of_benefits: payload.assignmentOfBenefits,
            release_of_information: payload.releaseOfInformation,
            diagnoses: payload.diagnoses,
            services: payload.services.map((service) => ({
                date_of_service: formatDate(service.dateOfService, DateFormats.HYPHEN_DATE),
                date_of_service_end: formatDate(service.dateOfServiceEnd, DateFormats.HYPHEN_DATE),
                procedure_code: service.procedureCode,
                procedure_code_description: service.procedureCodeDescription,
                modifier_codes: service.modifierCodes,
                ndc: service.ndc,
                diagnoses: service.diagnoses,
                billing_quantity: service.billingQty,
                billing_uom: service.billingQtyUom,
                provider_charge: service.providerCharge,
                dispensed_quantity: service.dispensedQty,
                dispensed_uom: service.dispensedQtyUom,
            })),
        };

        return (await postClaim({ npi: getState().auth.selectedNpi!, formattedClaim }))
            ?.transaction_id;
    };
